<script lang="ts" setup>
import { onMounted } from 'vue'
import { LOTTERY_ITEMS } from '~/resources/lobby-games'
import NextLotteryItem from '~/components/desktop/pages/lobby-games/next-lottery-item.vue'
import BaseInput from '~/components/common/base-input.vue'
import Datepicker from '@/components/common/datepicker.vue'
import { useLode } from '~/composables/lobby-games/use-lode'
import BaseDropdown from '~/components/common/base-dropdown.vue'
import { StringUtils } from '~/utils'
import { useDevice } from '#imports'

const {
  probeNumber,
  lotteryFilter,
  currentDate,
  changeDate,
  regions,
  lotteryData,
  guessNumbers,
  LODE_TABS,
  resetNumberDaily,
  luckyNumber,
  filterTextLottery,
  changeRegion,
  changeSearchNumberTab,
  tabNumber
} = useLode()

onMounted(() => {
  resetNumberDaily()
})

const { isSafari } = useDevice()
</script>
<template>
  <section class="lo-de">
    <div class="row">
      <div class="col-8 col--left">
        <div class="lo-de__header">
          <div class="base-title flex-box gap-8 mb-0">
            <h2 class="base-title__text">Kết quả xổ số</h2>
          </div>
          <div class="lo-de__header--filter">
            <div class="filter__input">
              <BaseInput v-model="probeNumber" type="tel" :maxLength="6" placeholder="Nhập số dò" />
            </div>
            <div class="filter__date">
              <Datepicker
                format="EEE - dd/MM/yyyy"
                :isRange="false"
                :isIconCalendar="false"
                placeholder="Chọn ngày"
                :disabledDates="currentDate"
                :defaultDate="lotteryFilter.date.toString()"
                @onSelectDate="changeDate"
              />
            </div>
            <div v-if="regions?.length" class="filter__select">
              <BaseDropdown
                :optionItems="regions"
                :valueSelected="lotteryFilter.region?.value?.toString()"
                @handleItemSelected="changeRegion"
              />
            </div>
          </div>
        </div>
        <div class="lo-de__probe">
          <div class="lo-de__probe--info">
            Xổ số
            {{ lotteryFilter.region?.label || lotteryFilter.region?.name }}
            <span>{{ filterTextLottery(lotteryData.lottery.title) }}</span>
          </div>
          <ul class="lo-de__probe--options">
            <li v-for="item in LODE_TABS" :key="item.key">
              <label>
                <input
                  type="radio"
                  name="searchBy"
                  :checked="item.value === tabNumber"
                  class="base-radio"
                  @click="changeSearchNumberTab(item.value)"
                />
                <div :class="{ active: item.value === tabNumber }">
                  {{ item.label }}
                </div>
              </label>
            </li>
          </ul>
        </div>
        <div v-if="Object.values(lotteryData.lottery.result)?.length" class="lo-de__content">
          <div class="lo-de__result--special">
            <label>Giải Đặc Biệt</label>
            <div
              v-html="guessNumbers(StringUtils.splitStringAndWrap(lotteryData.lottery.result?.special, 'p'), true)"
            ></div>
          </div>
          <ul class="lo-de__result">
            <li>
              <label>Giải Nhất</label>
              <div v-html="guessNumbers(lotteryData.lottery.result?.prize1)"></div>
            </li>
            <li>
              <label>Giải Nhì</label>
              <div v-html="guessNumbers(lotteryData.lottery.result?.prize2)"></div>
            </li>
            <li>
              <label>Giải Ba</label>
              <div v-html="guessNumbers(lotteryData.lottery.result?.prize3)"></div>
            </li>
            <li>
              <label>Giải Tư</label>
              <div v-html="guessNumbers(lotteryData.lottery.result?.prize4)"></div>
            </li>
            <li>
              <label>Giải Năm</label>
              <div v-html="guessNumbers(lotteryData.lottery.result?.prize5)"></div>
            </li>
            <li>
              <label>Giải Sáu</label>
              <div v-html="guessNumbers(lotteryData.lottery.result?.prize6)"></div>
            </li>
            <li>
              <label>Giải Bảy</label>
              <div v-html="guessNumbers(lotteryData.lottery.result?.prize7)"></div>
            </li>
            <li>
              <label>Giải Tám</label>
              <div v-html="guessNumbers(lotteryData.lottery.result?.prize8)"></div>
            </li>
          </ul>
        </div>
        <div v-else class="lo-de__nodata">
          <img src="/assets/images/components/lobby-games/lode-nodata.png" alt="No data" />
          <p>Kết quả đang được cập nhật</p>
        </div>
      </div>
      <div class="col-4 col--right">
        <div class="box-lucky-number mb-4" :class="{ isSafari: isSafari }">
          <h3 class="box-lucky-number__title">Con số may mắn<br />hôm nay</h3>
          <div class="box-lucky-number__number">
            <div>
              <span>{{ luckyNumber }}</span>
            </div>
          </div>
        </div>
        <template v-for="item in LOTTERY_ITEMS" :key="item.id">
          <NextLotteryItem :item="item" />
        </template>
      </div>
    </div>
  </section>
</template>
<style scoped lang="scss">
@import '~scssAsset/desktop/pages/lobby-games/section-lode.scss';
</style>
